(function ($) {
    $(function () {

        var block_submit_twice = false;


        $('#newsletter-form').submit(function (e) {
            e.preventDefault();

            $('.button__wrapper').addClass('d-none')

            var theForm = $(this);

            var data = grabFormAsObject(theForm);

            $.ajax({
                url: localize.ajaxurl,
                type: "POST",
                dataType: "json",
                data: {
                    action: "submit_form",
                    datas: data,
                },


                error(response) {
                    $('.button__wrapper').css('display', 'none');
                },

                success(response) {
                    console.log(response['fault']);
                    if (!response['fault']) {
                        const fancybox = new Fancybox.show([
                            {
                                src: "<h2>Sikeres hírlevél feliratkozás!</h2>",
                                type: "html",

                            },
                        ]);
                        $(':input', '#newsletter-form')
                            .not(':button, :submit')
                            .val('')
                        $('.button__wrapper').css('display', 'block');
                    } else {
                        const fancybox = new Fancybox.show([
                            {
                                src: "<h2>" + response['msg'] + "</h2>",
                                type: "html",

                            },
                        ],
                            {
                                mainClass: "error"
                            }
                        );
                    }

                }

            });

        });


    });
})(jQuery);

(function ($) {
    $(() => {

        function validateEmail(email) {
            var re = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
            return re.test(String(email).toLowerCase());
        }

        function validateJsFormRequire(jqueryForm, shouldShow, limitToFields = []) {
            let hasError = false;
            jqueryForm
                .parents('form')
                .find('[required],.show-required')
                .each(function (el) {
                    if (
                        !jQuery(this).val() ||
                        jQuery(this).attr('type') === 'email' && !validateEmail(jQuery(this).val()) ||
                        (jQuery(this).attr('type') === 'text') ||
                        jQuery(this).attr('type') === 'checkbox' && jQuery(this).prop('checked') == false) {
                        jQuery(this)
                            .parents('.form__item')
                            .toggleClass('has--error', shouldShow);
                        if (
                            limitToFields.length > 0 &&
                            limitToFields.indexOf(jQuery(this).attr('email')) !== -1
                        ) {
                            hasError = true;
                        }
                    }
                });

            return hasError;
        }

        const lineEq = (y2, y1, x2, x1, currentVal) => {
            // y = mx + b
            const m = (y2 - y1) / (x2 - x1);
            const b = y1 - m * x1;
            return m * currentVal + b;
        };

        const distanceThreshold = { min: 0, max: 75 };
        const opacityInterval = { from: 0, to: 1 };

        $('.js-form-submit').each(function () {
            const $that = $(this);

            new Nearby($that[0], {
                onProgress: distance => {
                    const o = lineEq(
                        opacityInterval.from,
                        opacityInterval.to,
                        distanceThreshold.max,
                        distanceThreshold.min,
                        distance
                    );
                    validateJsFormRequire($that, o == 1);
                }
            });
        });
    });
})(jQuery);